export const URLs = {
  blog: 'https://landing.tp.games/blog',
  termsAndConditions: 'https://landing.tp.games/terms-and-conditions', // TODO: Implement these pages
  privacyPolicy: 'https://landing.tp.games/privacy',
  hoster: '/hoster/',
  controller: '/controller/',
  // TODO: These should probably be fed in by a config in firebase
  donate: 'https://buy.stripe.com/eVa5kpa7F0UB4ve8ww',
} as const;

/**@deprecated use `URLs.hoster' instead */
export const hosterUrl = URLs.hoster;
/**@deprecated use `URLs.controller' instead */
export const controllerUrl = URLs.controller;

export function getCodeUrl(code: string) {
  return `/controller/#/${code}`;
}

export function replaceControllerCodeUrl(code: string) {
  const url = new URL(window.location.href);
  url.hash = `/${code}`;
  window.history.replaceState(window.history.state, '', url);
}

export function redirect(url: string) {
  window.location.href = url;
}
